export const routes_exception =  [
  // ...
  //only write new route above this route
  {
    path: '*',
    name: '401',
    meta: (route) => ({ authRequired: false }),
    component: () => import('../views/pages/401/index.vue')
  },
  {
    path: '*',
    name: '404',
    meta: (route) => ({ authRequired: false }),
    component: () => import('../views/pages/404/index.vue')
  },

]